import {
  createSlice,
  createEntityAdapter,
  createSelector,
  createAsyncThunk,
} from "@reduxjs/toolkit";
import { createWrapper } from "admin/api/axiosWrapper";
import { ErrorResponse } from "admin/types/errorResponse";
import { AutoTranslation } from "admin/types/autoTranslation";
import {
  isFulfilledAction,
  isPendingAction,
  isRejectedAction,
} from "admin/utils/sliceUtil";
import { PageContext } from "../types/pageContext";
import { AdminTypes } from "../constants/adminTypes";
import { API_BASE_PATH, COMPANY_ADMIN_API_VER } from "../constants/constants";
import { RootState } from "admin/store";

const key = "autoTranslation";
const adapter = createEntityAdapter<AutoTranslation.AutoTranslation, string>({
  selectId: (autoTranslation) => autoTranslation,
});

const initialStateValues: AutoTranslation.AutoTranslationState = {
  errors: null,
  loading: false,
};

const initialState = adapter.getInitialState(initialStateValues);

/** Async * */
export const fetchAutoTranslation = createAsyncThunk<
  {
    translation: AutoTranslation.AutoTranslation;
  },
  { context: PageContext.PageContext; params: any },
  {
    rejectValue: ErrorResponse;
  }
>(`${key}/fetchAutoTranslation`, async (args, { rejectWithValue }) => {
  try {
    const { context, params } = args;
    const url =
      context.adminType === AdminTypes.manager
        ? `${API_BASE_PATH}/manager/auto_translations.json`
        : `${API_BASE_PATH}/company_admin/${COMPANY_ADMIN_API_VER}/auto_translations.json`;
    const result = await createWrapper().post(url, params);
    console.log(result);
    return result.data.translation;
  } catch (err) {
    return rejectWithValue(err.data.errors);
  }
});

/** slice * */
export const autoTranslationSlice = createSlice({
  name: key,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // 一旦slice単位で共通化
      .addMatcher(isPendingAction(key), (state) => {
        state.loading = true;
      })
      .addMatcher(isFulfilledAction(key), (state) => {
        state.loading = false;
      })
      .addMatcher(isRejectedAction(key), (state, action: any) => {
        state.errors = action.payload;
        state.loading = false;
      });
  },
});

/** selector * */
const stateSelector = (state: RootState) => state[key];

export const loadingSelector = createSelector(
  stateSelector,
  (state) => state.loading,
);
